<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: "Teacher",
  components: {},
}
</script>

<style scoped>

</style>
